// import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import {Component, Inject, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import {environment} from 'src/environments/environment';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';


@Component({
    selector: 'dialog-salref-detail-direct',
    templateUrl: 'dialog-salref-detail-direct.component.html',
    styleUrls: ['dialog-salref-detail-direct.component.scss','../dossier-post/dossier-post.component.scss']
})
export class DialogSalRefDetailDirect implements OnInit {

    BOCC_URL: string = environment.BOCC_URL;
    salRefDetailFormGroup : FormGroup;
    tooltipParametreSelected : string = "";
    txtConventionInfoParamSelected : string = "";
    filteredRemuneration: Observable<any>;
    ptAttentions = [];
    errorRemuneration: boolean = false;
    optionIncludeInsaleRef: boolean = true;

    constructor(
        public dialogRef: MatDialogRef<DialogSalRefDetailDirect>,
        private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        let init_TYPE_REMUNERATION_autocomplete_options = this.data.optionsTypeRemuneration.filter(option => option.Value === this.data.initialisation.TYPE_REMUNERATION);

        this.salRefDetailFormGroup = this.formBuilder.group({
            dossier_id: new FormControl(this.data.dossier_id),
            TYPE_REMUNERATION_autocomplete: new FormControl(init_TYPE_REMUNERATION_autocomplete_options.length ? init_TYPE_REMUNERATION_autocomplete_options[0] : undefined),
            parametre_id_initial: new FormControl(this.data.initialisation.TYPE_REMUNERATION),
            TOTAL: new FormControl({value: 0.0, disabled: true}),
        });
        if (this.data.initialisation.TYPE_REMUNERATION) {
            this.tooltipParametreSelected = this.data.optionsTypeRemuneration.find((el) => el.Value == this.data.initialisation.TYPE_REMUNERATION).Tooltip;
        }
        this.tooltipParametreSelected
        for (const [name, init] of Object.entries(this.data.initialisation)) {
            this.salRefDetailFormGroup.addControl(name, new FormControl(init))
        }
        this.data.periodeValues.forEach(element => {
            this.salRefDetailFormGroup.addControl('MONTH_VALUE_' + element.date_short + '_' + element.id, new FormControl(element.value));
        });
        this.computeTotal();
        this.updateAside();
        this.data.optionsTypeRemuneration.sort(function(a, b) {
            return a['Libelle'] - b['Libelle'];
        });

        this.filteredRemuneration = this.salRefDetailFormGroup.get('TYPE_REMUNERATION_autocomplete').valueChanges.pipe(
            startWith(''),
            map(value => typeof value === 'string' ? value : value.Libelle),
            map(Libelle => Libelle ? this._filter(Libelle) : this.data.optionsTypeRemuneration.slice())
        );
    }

    displayRemuneration(option) {
        return option ? option.Libelle : undefined;
    }

    remunerationSelected(option){
        this.tooltipParametreSelected = option.Tooltip;
        this.salRefDetailFormGroup.get('TYPE_REMUNERATION').setValue(option.Value);
        this.txtConventionInfoParamSelected = option.txtConventionInfo;
        this.errorRemuneration = false;
        this.optionIncludeInsaleRef = option["includedInSalRef"];
    }

    private _filter(Libelle: string): [] {
        const filterValue = Libelle.toLowerCase();
        return this.data.optionsTypeRemuneration.filter(option => option.Libelle.toLowerCase().indexOf(filterValue) > -1);
    }

    reduceFontSizeIfNeeded() {
        document.querySelectorAll('.mat-option-text').forEach(opt => {
            let diff_width_not_displayed = opt.scrollWidth - opt.clientWidth;
            if (diff_width_not_displayed > 0) {
                let initialFontSize = Number(window.getComputedStyle(opt).getPropertyValue('font-size').match(/\d+/)[0]);
                let fontSize = Math.floor(initialFontSize * opt.clientWidth / opt.scrollWidth);
                (<HTMLElement> opt).style['font-size'] = fontSize + 'px';
            }
        });

    }
    dismissDialog(option=null){
        if(option === null || this.checkRemuneration()){
            this.data.periodeValues.forEach(element => {
                if (!this.salRefDetailFormGroup.get("MONTH_VALUE_" + element.date_short + '_' + element.id).value)
                    this.salRefDetailFormGroup.get("MONTH_VALUE_" + element.date_short + '_' + element.id).setValue(0)
            });
            const values = this.salRefDetailFormGroup.getRawValue();
            values["includedInSalRef"] = this.optionIncludeInsaleRef;
            this.dialogRef.close({option: option, values: values});
        }
    }
    modifyValueToggle(event,formGroup, paramForm, isModifiable = true){
        if (isModifiable) {
            if(event && event.target && event.target.checked){
                formGroup.get(paramForm).setValue("TRUE")
            }else{
                formGroup.get(paramForm).setValue("FALSE")
            }
        }
    }
    toggleChipPeriode(chip) {
        let i = this.data.optionsPeriod.length;
        this.data.optionsPeriod.forEach(c => {
            chip.Value !== c.Value ? c.selected = false : (c.selected == true ? c.selected = false : c.selected = true);
            if(c.selected){
                this.salRefDetailFormGroup.get("v_periode").setValue(c.Value);
            }else{
                i--;
            }
        });
        if(i==0){
            this.salRefDetailFormGroup.get("v_periode").setValue("");
        }
    }
    propagateValue() {
        let toPropagate = this.salRefDetailFormGroup.get("MONTH_VALUE_" + this.data.periodeValues[0].date_short + '_' + this.data.periodeValues[0].id).value;
        this.data.periodeValues.forEach((element, index) => {
            if (index > 0)
                this.salRefDetailFormGroup.get("MONTH_VALUE_" + element.date_short + '_' + element.id).setValue(toPropagate);
        });
        this.computeTotal();
        this.updateAside();
    }
    emptyValues() {
        this.data.periodeValues.forEach(element => {
            this.salRefDetailFormGroup.get("MONTH_VALUE_" + element.date_short + '_' + element.id).setValue(0);
        });
        this.computeTotal();
        this.updateAside();
    }
    computeTotal() {
        let total = 0.0;
        this.data.periodeValues.forEach(element => {
            total += this.salRefDetailFormGroup.get("MONTH_VALUE_" + element.date_short + '_' + element.id).value;
        });
        this.salRefDetailFormGroup.get("TOTAL").setValue(total);
    }
    updateAside() {
        let ptAttentions = [];
        let montants = {};
        this.data.periodeValues.forEach(element => {
            montants[element.date_str] = this.salRefDetailFormGroup.get("MONTH_VALUE_" + element.date_short + '_' + element.id).value;
        });
        let index_with_amount:any = Object.values(montants).reduce( (carry:Array<Number>, value, index) => {
            if (value !== 0 && value !== null)
                carry.push(index);
            return carry;
        }, []);
        let nb_month_between_value = [];
        for (let index = 0; index < index_with_amount.length - 1; index++) {
            nb_month_between_value.push(index_with_amount[index + 1] - index_with_amount[index]);
        }
        if (this.data.param_display['v_periode'] && ['men','tri','sem','an'].includes(this.salRefDetailFormGroup.get("v_periode").value)) {
            let periodicite = 0;
            let v_periode_str = '';
            switch (this.salRefDetailFormGroup.get("v_periode").value) {
                case 'men':// tous les 1 mois // 12 fois par an
                    periodicite = 1;
                    v_periode_str = 'mensuelle';
                    break;
                case 'tri':// tous les 3 mois // 4 fois par an
                    periodicite = 3;
                    v_periode_str = 'trimestrielle';
                    break;
                case 'sem':// tous les 6 mois // 2 fois par an
                    periodicite = 6;
                    v_periode_str = 'semestrielle';
                    break;
                case 'an':// tous les 12 mois // 1 fois par an
                    periodicite = 12;
                    v_periode_str = 'annuelle';
                    break;
                default:
                    break;
            }
            if (periodicite > 0) {
                let nb_amount_expected = Object.keys(montants).length / periodicite;
                let first_index_with_amount = index_with_amount[0];
                let expected_index = [];
                for (let index = 0; index < nb_amount_expected; index++) {
                    expected_index.push(first_index_with_amount + periodicite * index);
                }
                let nb_month_between_value_en_erreur = nb_month_between_value.reduce(function(carry, nb_month, idx) { if (nb_month != periodicite) carry.push(idx); return carry; }, []);
                let erreur_index = [];
                for (let index = 0; index < nb_month_between_value_en_erreur.length; index++) {
                    const element = nb_month_between_value_en_erreur[index];
                    erreur_index.push(index_with_amount[element + 1])
                }
                let intersect = expected_index.filter(value => erreur_index.includes(value));
                erreur_index = erreur_index.filter((e) => !intersect.includes(e));
                expected_index = expected_index.filter((e) => !intersect.includes(e));

                let date_str_en_trop = [];
                let date_str_missing = [];
                for (let index = 0; index < erreur_index.length; index++) {
                    date_str_en_trop.push(Object.keys(montants)[erreur_index[index]]);
                }
                for (let index = 0; index < expected_index.length; index++) {
                    if (!index_with_amount.includes(expected_index[index]))
                        date_str_missing.push(Object.keys(montants)[expected_index[index]]);
                }
                
                if (first_index_with_amount === undefined) {
                    ptAttentions.push({prefix: `Aucun montant n'a été saisi`, date_str: [], suffix: ""})
                } else {
                    if (date_str_en_trop.length) {
                        ptAttentions.push({prefix: `Mois excédant(s) suivant la récurrence de la périodicité ${v_periode_str} : `, date_str: date_str_en_trop, suffix: ""})
                    }
                    if (date_str_missing.length) {
                        ptAttentions.push({prefix: `Mois manquant(s) suivant la récurrence de la périodicité ${v_periode_str} : `, date_str: date_str_missing, suffix: ""})
                    }
                }
            }
        } else if (this.data.param_display['v_periode'] && this.salRefDetailFormGroup.get("v_periode").value == "ex") {// aucune contrainte
        }
        this.ptAttentions = ptAttentions;

    }

    checkRemuneration(){
        this.errorRemuneration = false;
        const obj = this.salRefDetailFormGroup.get('TYPE_REMUNERATION_autocomplete').value;
        const value = this.salRefDetailFormGroup.get('TYPE_REMUNERATION').value;
        if(obj && obj.Value && obj.Value == value){
            return true;
        }
        else{
            this.errorRemuneration = true;
            return false;
        }
    }
}